import React from 'react';
import RulesTable from './RulesTable';
import { Row, Col, Container } from 'react-bootstrap';
import { BsGear } from 'react-icons/bs';
import PageHeader from 'Utils/PageHeader';

const Results = (props) => {
  return (
    <Col className='p-0'>
      <Container>
        <PageHeader
          header='Sampling Rules'
          icon={BsGear}
          tooltip="Sampling rules allow you to set how much data to analyze during a discovery."
        />
        <Row className='widget-row'>
          <Col>
            <RulesTable
              rulesList={props.rulesList}
              pageSize={10}
            />
          </Col>
        </Row>
      </Container>
    </Col>
  );
}

export default Results;